import { NgModule } from '@angular/core';
import { MAT_MENU_SCROLL_STRATEGY, MatMenuModule } from '@angular/material/menu';
import { Overlay, ScrollStrategy } from '@angular/cdk/overlay';

@NgModule({
  imports: [MatMenuModule],
  exports: [MatMenuModule],
  providers: [
    {
      provide: MAT_MENU_SCROLL_STRATEGY,
      deps: [Overlay],
      useFactory: (overlay: Overlay) => (): ScrollStrategy => overlay.scrollStrategies.close(),
    },
  ],
})
export class MenuModule {}
